import { Grid, useTheme } from "@mui/material";
import { Observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { sxClsx } from "utils/styleClsx";
interface IGutters {
    justifyContent?:
        | "flex-start"
        | "center"
        | "flex-end"
        | "space-between"
        | "space-around"
        | "space-evenly";
    alignItems?: "flex-start" | "center" | "flex-end" | "stretch" | "baseline";
    height?: string;
    bigGutter?: boolean;
    tinyGutter?: boolean;
    overflow?: string;
    children?: React.ReactNode;
}

const Gutters: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<IGutters>>
> = (props) => {
    const theme = useTheme();

    return (
        <Observer>
            {() => (
                <>
                    <div
                        style={{
                            display: "flex",
                            overflow: props.overflow ?? "auto",
                            height: props.height ?? "100%",
                        }}
                    >
                        <Grid
                            sx={sxClsx(
                                props.bigGutter && {
                                    [theme.breakpoints.only("sm")]: {
                                        width: "0.5%",
                                    },
                                    [theme.breakpoints.only("md")]: {
                                        width: "5%",
                                    },
                                    [theme.breakpoints.only("lg")]: {
                                        width: "10%",
                                    },
                                    [theme.breakpoints.up("xl")]: {
                                        width: "14%",
                                    },
                                },
                                !props.bigGutter &&
                                    props.tinyGutter && {
                                        [theme.breakpoints.only("sm")]: {
                                            width: "0.25%",
                                        },
                                        [theme.breakpoints.only("md")]: {
                                            width: "2%",
                                        },
                                        [theme.breakpoints.only("lg")]: {
                                            width: "5.5%",
                                        },
                                        [theme.breakpoints.up("xl")]: {
                                            width: "8%",
                                        },
                                    },
                                !props.bigGutter &&
                                    !props.tinyGutter && {
                                        [theme.breakpoints.only("sm")]: {
                                            width: "0.5%",
                                        },
                                        [theme.breakpoints.only("md")]: {
                                            width: "2%",
                                        },
                                        [theme.breakpoints.only("lg")]: {
                                            width: "6%",
                                        },
                                        [theme.breakpoints.up("xl")]: {
                                            width: "10%",
                                        },
                                    },
                            )}
                        />
                        <Grid
                            sx={sxClsx(
                                {
                                    height: "100%",
                                    justifyContent:
                                        props.justifyContent ?? "flex-start",
                                    alignItems: props.alignItems ?? "stretch",
                                },
                                !props.bigGutter &&
                                    !props.tinyGutter && {
                                        [theme.breakpoints.only("sm")]: {
                                            width: "99%",
                                        },
                                        [theme.breakpoints.only("md")]: {
                                            width: "96%",
                                        },
                                        [theme.breakpoints.only("lg")]: {
                                            width: "88%",
                                        },
                                        [theme.breakpoints.up("xl")]: {
                                            width: "80%",
                                        },
                                    },
                                !props.bigGutter &&
                                    props.tinyGutter && {
                                        [theme.breakpoints.only("sm")]: {
                                            width: "99%",
                                        },
                                        [theme.breakpoints.only("md")]: {
                                            width: "98%",
                                        },
                                        [theme.breakpoints.only("lg")]: {
                                            width: "94.5%",
                                        },
                                        [theme.breakpoints.up("xl")]: {
                                            width: "92%",
                                        },
                                    },
                                props.bigGutter && {
                                    [theme.breakpoints.only("sm")]: {
                                        width: "99%",
                                    },
                                    [theme.breakpoints.only("md")]: {
                                        width: "90%",
                                    },
                                    [theme.breakpoints.only("lg")]: {
                                        width: "80%",
                                    },
                                    [theme.breakpoints.up("xl")]: {
                                        width: "72%",
                                    },
                                },
                            )}
                        >
                            {props.children}
                        </Grid>
                        <Grid
                            sx={sxClsx(
                                props.bigGutter && {
                                    [theme.breakpoints.only("sm")]: {
                                        width: "0.5%",
                                    },
                                    [theme.breakpoints.only("md")]: {
                                        width: "5%",
                                    },
                                    [theme.breakpoints.only("lg")]: {
                                        width: "10%",
                                    },
                                    [theme.breakpoints.up("xl")]: {
                                        width: "14%",
                                    },
                                },
                                !props.bigGutter &&
                                    props.tinyGutter && {
                                        [theme.breakpoints.only("sm")]: {
                                            width: "0.25%",
                                        },
                                        [theme.breakpoints.only("md")]: {
                                            width: "2%",
                                        },
                                        [theme.breakpoints.only("lg")]: {
                                            width: "5.5%",
                                        },
                                        [theme.breakpoints.up("xl")]: {
                                            width: "8%",
                                        },
                                    },
                                !props.bigGutter &&
                                    !props.tinyGutter && {
                                        [theme.breakpoints.only("sm")]: {
                                            width: "0.5%",
                                        },
                                        [theme.breakpoints.only("md")]: {
                                            width: "2%",
                                        },
                                        [theme.breakpoints.only("lg")]: {
                                            width: "6%",
                                        },
                                        [theme.breakpoints.up("xl")]: {
                                            width: "10%",
                                        },
                                    },
                            )}
                        />
                    </div>
                </>
            )}
        </Observer>
    );
};

export default Gutters;
